/**
 * SignalR event name constants for the /hubs/user hub.
 */
export const SIGNALR_EVENTS = {
  CCOF_CARD_CHANGED: "ccof-card-changed",
  PATIENT_AR_CHANGED: "patient-ar-changed",
} as const;

export type SignalREventName =
  (typeof SIGNALR_EVENTS)[keyof typeof SIGNALR_EVENTS];

/** Hub method names invoked via `connection.invoke(...)`. */
export const SIGNALR_METHODS = {
  JOIN_PRACTICE_CHANNEL: "JoinPracticeChannel",
  LEAVE_PRACTICE_CHANNEL: "LeavePracticeChannel",
  JOIN_PATIENT_CHANNEL: "JoinPatientChannel",
  LEAVE_PATIENT_CHANNEL: "LeavePatientChannel",
} as const;
